import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { useEventListener } from '@vueuse/core'
import { emitter } from '@/plugins/emitter'
import LoginForms from '@/components/auth/LoginSpecialForms.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginFormDialog',
  setup(__props) {

/**
 * クイックメール等のログイン誘導（vue-final-modal）。
 * open は mitt（open-loginform-dialog）。未移行 hub 発火は emitter の hub→mitt forward。
 */
const OPEN_LOGINFORM_DIALOG = 'open-loginform-dialog'

const visible = ref(false)
const fullscreenLoading = ref(false)

function openLoginformDialog() {
  visible.value = true
}

function closeLoginformDialog() {
  visible.value = false
}

function onVisibleInput(value: boolean) {
  visible.value = value
}

onBeforeMount(() => {
  emitter.on(OPEN_LOGINFORM_DIALOG, openLoginformDialog)
})

onBeforeUnmount(() => {
  emitter.off(OPEN_LOGINFORM_DIALOG, openLoginformDialog)
})

useEventListener(window, 'popstate', closeLoginformDialog)

return { __sfc: true,OPEN_LOGINFORM_DIALOG, visible, fullscreenLoading, openLoginformDialog, closeLoginformDialog, onVisibleInput, LoginForms }
}

})